<form-control
  (inputChanged)="onIndustryTitleInput($event)"
  (selected)="onIndustryTitleSelect($event)"
  [config]="industryTitleConfig"
  [control]="formGroup.get(industryTitleProp())"
  [direction]="direction"
  [group]="formGroup"
>
  @if (formGroup.get(industryTitleProp()).valid && loadingIndustryTitle) {
    <p hint class="u-absolute t-caption">
      {{ industryTitleConfig.messages.loading }}
    </p>
  }
  @if (
    formGroup.get(industryTitleProp()).valid &&
    !loadingIndustryTitle &&
    showIndustryTitleError
  ) {
    <p class="u-absolute t-caption t-error" hint>
      {{ industryTitleConfig.messages.error }}
    </p>
  }
</form-control>

<form-control
  (inputChanged)="onSICCodeInput($event)"
  (selected)="onSICCodeSelect($event)"
  [config]="sicCodeConfig"
  [control]="formGroup.get(sicCodeProp())"
  [direction]="direction"
  [group]="formGroup"
>
  @if (formGroup.get(sicCodeProp()).valid && loadingSicCodes) {
    <p hint class="u-absolute t-caption">
      {{ sicCodeConfig.messages.loading }}
    </p>
  }
  @if (
    formGroup.get(sicCodeProp()).valid && !loadingSicCodes && showSicCodeError
  ) {
    <p hint class="u-absolute t-caption t-error">
      {{ sicCodeConfig.messages.error }}
    </p>
  }
</form-control>
